export default __webpack_public_path__ + "static/media/img-0219-mexico-premium-face.1618d20f.png";